export enum OrdersFilter {
  Open = "open",
  Completed = "completed"
}
